export class StringHelper {

    // Returns a string that is properly escaped to show up correctly in am4charts labels and values.
    static escapeAmchartsString(str: string) : string {
        return str
            .replaceAll("[", "[[")
            .replaceAll("]", "]]")
            .replaceAll("{", "{{")
            .replaceAll("}", "}}")
    }
}